import { router } from "@inertiajs/react";
import { pushActionToast } from "@/stores/actionToast";

export const OFFLINE_SCREEN_TEXT = "Нет сети — этот экран откроется, когда связь вернётся.";

type RouterEvents = Pick<typeof router, "on" | "visit">;

function isNetworkFailure(error: unknown): boolean {
  const axiosLike = error as { isAxiosError?: boolean; response?: unknown } | null;
  return Boolean(axiosLike?.isAxiosError) && !axiosLike?.response;
}

// Task pages open offline through the service worker; any other GET visit fails without a
// network and would otherwise end in a silent unhandled rejection.
export function watchOfflineNavigation(r: RouterEvents = router): void {
  let pendingGetUrl: string | null = null;
  r.on("start", (event) => {
    const { visit } = event.detail;
    pendingGetUrl = visit.method === "get" ? visit.url.href : null;
  });
  r.on("finish", () => {
    pendingGetUrl = null;
  });
  r.on("exception", (event) => {
    if (!pendingGetUrl || !isNetworkFailure(event.detail.exception)) return;
    const url = pendingGetUrl;
    event.preventDefault();
    pushActionToast({
      key: "offline-navigation",
      message: OFFLINE_SCREEN_TEXT,
      actionLabel: "Повторить",
      onAction: () => r.visit(url),
    });
  });
}
